export const MSG_022 = `No hay registros de acuerdos sell in en el sistema`;

export const MSG_035 = `El volumen para cada mes del acuerdo comercial sell in debe ser una cantidad múltiplo del MOQ registrado para el producto. Revise la información registrada.`;

export const MSG_036 = (info) => {
  const { zone, client, product } = info;
  return `El registro del acuerdo comercial sell in para la zona ${zone}, cliente ${client} y producto ${product} se realizó de forma exitosa.`;
};
